import Vue from 'vue'
import Router from 'vue-router'
import VueIziToast from 'vue-izitoast'

import * as Helper from '@/shared/helper'
import * as Auth from '@/shared/auth'

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')

const Config = () => import('@/views/Config')

const Inquiry = () => import('@/views/info/service/Inquiry')
const ViewInquiry = () => import('@/views/info/service/ViewInquiry')
// const ServiceRequest = () => import('@/views/info/service/ServiceRequest')
// const ViewServiceRequest = () => import('@/views/info/service/ViewServiceRequest')

const SearchHistory = () => import('@/views/info/search-history/HistoryList')
const SearchHistoryUserList = () => import('@/views/info/search-history/UserList')
const SearchHistoryUser = () => import('@/views/info/search-history/User')

const News = () => import('@/views/management/content/News')
const ManageNews = () => import('@/views/management/content/ManageNews')
const NewsCategory = () => import('@/views/management/content/NewsCategory')
const ManageNewsCategory = () => import('@/views/management/content/ManageNewsCategory')
const Faq = () => import('@/views/management/content/Faq')
const ManageFaq = () => import('@/views/management/content/ManageFaq')
const FaultFinding = () => import('@/views/management/content/FaultFinding')
const ManageFaultFinding = () => import('@/views/management/content/ManageFaultFinding')
const FaultFindingCategory = () => import('@/views/management/content/FaultFindingCategory')
const ManageFaultFindingCategory = () => import('@/views/management/content/ManageFaultFindingCategory')
const Slide = () => import('@/views/management/content/Slide')
const ManageSlide = () => import('@/views/management/content/ManageSlide')
const Pages = () => import('@/views/management/content/Pages')
const ManagePage = () => import('@/views/management/content/ManagePage')

const User = () => import('@/views/management/account/User')
const ManageUser = () => import('@/views/management/account/ManageUser')
const Admin = () => import('@/views/management/account/Admin')
const ManageAdmin = () => import('@/views/management/account/ManageAdmin')
const Officer = () => import('@/views/management/account/Officer')
const ManageOfficer = () => import('@/views/management/account/ManageOfficer')

const Offices = () => import('@/views/management/office/Offices')
const ManageOffice = () => import('@/views/management/office/ManageOffice')
const Countries = () => import('@/views/management/office/Countries')
const ManageCountry = () => import('@/views/management/office/ManageCountry')
const PrivacyPolicies = () => import('@/views/management/office/PrivacyPolicies')
const ManagePrivacyPolicy = () => import('@/views/management/office/ManagePrivacyPolicy')
const Banners = () => import('@/views/management/office/Banners')
const ManageBanner = () => import('@/views/management/office/ManageBanner')
const BannerInteraction = () => import('@/views/management/office/BannerInteraction')

const Import = () => import('@/views/Import')
const ImportTwoWheel = () => import('@/views/ImportTwoWheel')

// forum
const ForumCategory = () => import('@/views/management/forum/ForumCategory')
const ManageForumCategory = () => import('@/views/management/forum/ManageForumCategory')
const ForumSubcategory = () => import('@/views/management/forum/ForumSubcategory')
const ManageForumSubcategory = () => import('@/views/management/forum/ManageForumSubcategory')
const ForumPosts = () => import('@/views/management/forum/ForumPosts')
const ForumPost = () => import('@/views/management/forum/ForumPost')
const ManageForumPost = () => import('@/views/management/forum/ManageForumPost')
const ManageForumPostComment = () => import('@/views/management/forum/ManageForumPostComment')
const ForumConfig = () => import('@/views/management/forum/ForumConfig')
const ForumTnc = () => import('@/views/management/forum/ForumTnc')
const ManageForumTnc = () => import('@/views/management/forum/ManageForumTnc')

const ForumCategoryPostCommentReport = () => import('@/views/info/report/ForumCategoryPostComment')
const ForumProductMentionReport = () => import('@/views/info/report/ForumProductMention')
const ForumMostEngagedReport = () => import('@/views/info/report/ForumMostEngaged')
const ForumContactRequestReport = () => import('@/views/info/report/ForumContactRequest')

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')

Vue.use(Router)

const router = new Router({
  mode: 'history', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [{
    path: '/',
    meta: { requireAuth: true },
    redirect: '/office/inquiry',
    name: 'Home',
    component: DefaultContainer,
    children: [{
      path: 'search-history',
      meta: { requireAuth: true },
      redirect: '/search-history/list',
      name: 'Search History',
      component: {
        render(c) { return c('router-view') }
      },
      children: [{
        path: 'list',
        meta: { requireAuth: true },
        name: 'Search History List',
        component: SearchHistory
      }, {
        path: 'user',
        meta: { requireAuth: true },
        name: 'User List',
        component: SearchHistoryUserList
      }, {
        path: 'user/:id',
        meta: { requireAuth: true },
        name: 'User Search History',
        component: SearchHistoryUser
      }]
    }, {
      path: 'content',
      meta: { requireAuth: true, admin: true },
      redirect: '/content/news',
      name: 'Content',
      component: {
        render(c) { return c('router-view') }
      },
      children: [{
        path: 'slide',
        meta: { requireAuth: true, admin: true },
        name: 'Slide',
        component: Slide
      }, {
        path: 'slide/manage/:id',
        meta: { requireAuth: true, admin: true },
        name: 'Manage Slide',
        component: ManageSlide
      }, {
        path: 'page',
        meta: { requireAuth: true, admin: true },
        name: 'Page',
        component: Pages
      }, {
        path: 'page/manage/:id',
        meta: { requireAuth: true, admin: true },
        name: 'Manage Page',
        component: ManagePage
      }, {
        path: 'news-category',
        meta: { requireAuth: true, admin: true },
        name: 'News Category',
        component: NewsCategory
      }, {
        path: 'news-category/manage/:id',
        meta: { requireAuth: true, admin: true },
        name: 'Manage News Category',
        component: ManageNewsCategory
      }, {
        path: 'faq',
        meta: { requireAuth: true, admin: true },
        name: 'FAQ',
        component: Faq
      }, {
        path: 'faq/manage/:id',
        meta: { requireAuth: true, admin: true },
        name: 'Manage FAQ',
        component: ManageFaq
      }, {
        path: 'fault-finding',
        meta: { requireAuth: true, admin: true },
        name: 'Fault Finding',
        component: FaultFinding
      }, {
        path: 'fault-finding/manage/:id',
        meta: { requireAuth: true, admin: true },
        name: 'Manage Fault Finding',
        component: ManageFaultFinding
      }, {
        path: 'fault-finding-category',
        meta: { requireAuth: true, admin: true },
        name: 'Fault Finding Category',
        component: FaultFindingCategory
      }, {
        path: 'fault-finding-category/manage/:id',
        meta: { requireAuth: true, admin: true },
        name: 'Manage Fault Finding Category',
        component: ManageFaultFindingCategory
      }]
    }, {
      path: 'account',
      meta: { requireAuth: true },
      redirect: '/account/user',
      name: 'Account',
      component: {
        render(c) { return c('router-view') }
      },
      children: [{
        path: 'user',
        meta: { requireAuth: true },
        name: 'User',
        component: User
      }, {
        path: 'user/manage/:id',
        meta: { requireAuth: true },
        name: 'Manage User',
        component: ManageUser
      }, {
        path: 'admin',
        meta: { requireAuth: true, admin: true },
        name: 'Admin',
        component: Admin
      }, {
        path: 'admin/manage/:id',
        meta: { requireAuth: true, admin: true },
        name: 'Manage Admin',
        component: ManageAdmin
      }, {
        path: 'officer',
        meta: { requireAuth: true, admin: true },
        name: 'Officer',
        component: Officer
      }, {
        path: 'officer/manage/:id',
        meta: { requireAuth: true, admin: true },
        name: 'Manage Officer',
        component: ManageOfficer
      }]
    }, {
      path: 'office',
      meta: { requireAuth: true },
      redirect: '/office/offices',
      name: 'Office',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'inquiry',
          meta: { requireAuth: true },
          name: 'Inquiry',
          component: Inquiry
        }, {
          path: 'inquiry/view/:id',
          meta: { requireAuth: true },
          name: 'View Inquiry',
          component: ViewInquiry
          // },{
          //   path:'request',
          //   meta: { requireAuth: true },
          //   name:'Service Request',
          //   component:ServiceRequest
          // },{
          //   path:'request/view/:id',
          //   meta: { requireAuth: true },
          //   name:'View Service Request',
          //   component:ViewServiceRequest
          // }
        }, {
          path: 'country',
          meta: { requireAuth: true, admin: true },
          name: 'Countries',
          component: Countries
        }, {
          path: 'country/manage/:id',
          meta: { requireAuth: true, admin: true },
          name: 'Manage Country',
          component: ManageCountry
        }, {
          path: 'offices',
          meta: { requireAuth: true },
          name: 'Offices',
          component: Offices
        }, {
          path: 'manage/:id',
          meta: { requireAuth: true },
          name: 'Manage Office',
          component: ManageOffice
        }, {
          path: 'privacy-policy',
          meta: { requireAuth: true },
          name: 'Privacy Policies',
          component: PrivacyPolicies
        }, {
          path: 'privacy-policy/manage/:id',
          meta: { requireAuth: true },
          name: 'Manage Privacy Policy',
          component: ManagePrivacyPolicy
        }, {
          path: 'banner',
          meta: { requireAuth: true },
          name: 'Banners',
          component: Banners
        }, {
          path: 'banner/manage/:id',
          meta: { requireAuth: true },
          name: 'Manage Banner',
          component: ManageBanner
        }, {
          path: 'banner/interaction/:id',
          meta: { requireAuth: true },
          name: 'Banner Interaction',
          component: BannerInteraction
        }, {
          path: 'news',
          meta: { requireAuth: true },
          name: 'News',
          component: News
        }, {
          path: 'news/manage/:id',
          meta: { requireAuth: true },
          name: 'Manage News',
          component: ManageNews
        },
        {
          path: 'forum/category',
          meta: { requireAuth: true },
          name: 'Forum Categories',
          component: ForumCategory
        }, {
          path: 'forum/category/manage/:id',
          meta: { requireAuth: true },
          name: 'Manage Forum Category',
          component: ManageForumCategory
        }, {
          path: 'forum/subcategory',
          meta: { requireAuth: true },
          name: 'Forum Subcategories',
          component: ForumSubcategory
        }, {
          path: 'forum/subcategory/manage/:id',
          meta: { requireAuth: true },
          name: 'Manage Forum Subcategory',
          component: ManageForumSubcategory
        }, {
          path: 'forum/posts',
          meta: { requireAuth: true },
          name: 'Forum Posts',
          component: ForumPosts
        }, {
          path: 'forum/post/:id',
          meta: { requireAuth: true },
          name: 'Forum Post and Comment',
          component: ForumPost
        }, {
          path: 'forum/post/manage/:id',
          meta: { requireAuth: true },
          name: 'Manage Forum Post',
          component: ManageForumPost
        }, {
          path: 'forum/post/:post_id/comment/manage/:id',
          meta: { requireAuth: true },
          name: 'Manage Forum Post Comment',
          component: ManageForumPostComment
        }, {
          path: 'forum/tnc',
          meta: { requireAuth: true },
          name: 'Forum Tncs',
          component: ForumTnc
        }, {
          path: 'forum/tnc/manage/:id',
          meta: { requireAuth: true },
          name: 'Manage Forum Tnc',
          component: ManageForumTnc
        }, {
          path: 'forum/config',
          meta: { requireAuth: true },
          name: 'Forum Access Config',
          component: ForumConfig
        }, {
          path: 'forum/report',
          meta: { requireAuth: true },
          name: 'Forum Report',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'category-post-comment',
            meta: { requireAuth: true },
            name: 'Forum Category Post Comment',
            component: ForumCategoryPostCommentReport
          },{
            path: 'product-mention',
            meta: { requireAuth: true },
            name: 'Forum Product Mention',
            component: ForumProductMentionReport
          },{
            path: 'most-engaged',
            meta: { requireAuth: true },
            name: 'Forum Most Engaged',
            component: ForumMostEngagedReport
          },{
            path: 'contact-request',
            meta: { requireAuth: true },
            name: 'Forum Contact Request',
            component: ForumContactRequestReport
          }]
        }
      ]
    }, {
      path: '/io',
      meta: { requireAuth: true, admin: true },
      name: 'IO',
      component: {
        render(c) { return c('router-view') }
      },
      children: [{
        path: 'import',
        meta: { requireAuth: true, admin: true },
        name: 'Import Four Wheel',
        component: Import,
      }, {
        path: 'import-twowheel',
        meta: { requireAuth: true, admin: true },
        name: 'Import Two Wheel',
        component: ImportTwoWheel,
      }]
    }, {
      path: '/config',
      meta: { requireAuth: true, admin: true },
      name: 'Config',
      component: Config
    }]
  }, {
    path: '/login',
    name: 'Login',
    component: Login
  }, {
    path: '/pages',
    redirect: '/pages/404',
    name: 'Pages',
    component: {
      render(c) { return c('router-view') }
    },
    children: [
      {
        path: '404',
        name: 'Page404',
        component: Page404
      }, {
        path: '500',
        name: 'Page500',
        component: Page500
      }
    ]
  }, {
    path: '/*',
    redirect: '/pages/404',
  }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) {
    let session = Auth.session.get()
    let role = Auth.session.get('role')
    let timestamp = Auth.session.get('pass_expire')
    let currentTimestamp = Date.now()

    if (((currentTimestamp - timestamp) / 1000 / 60 / 60) > 2) {
      Auth.session.delete()
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      })
    }

    if (session.passport) {
      next()
    } else {
      Auth.session.delete()
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      })
    }

    if (to.meta.admin) {
      //for restricting officer
      console.log(role)
      if (role == 'officer') {
        next({
          path: '/office'
        })
      }
    }
  }
  next()
})

export default router
